import { Store } from "redux";
import { SDK } from "@sdk";
import { iStore } from "../../store.model";
import { CreateHelpersForEntity } from "../../utils/entity-slice-creator";
import { CustomerPaymentMethodsSlice } from "./customer-payment-methods.slice";
import { iCustomerPaymentMethod } from "@sdk/customer-payment-methods/customer-payment-method-model";
import { customerPaymentMethodsDefaultQueryConfig } from "./customer-payment-methods-default-query";
import { QueryConfig } from "@/store/utils/query-config";

export const {
  loadEntityQueries: loadCustomerPaymentMethodsQuery,
  loadEntityById: loadCustomerPaymentMethodById,
  loadMoreEntityQueries: loadMoreCustomerPaymentMethodsQueries,
} = CreateHelpersForEntity<iStore, iCustomerPaymentMethod>({
  sliceName: "customerPaymentMethods",
  slice: CustomerPaymentMethodsSlice,
  isPaginatedQueries: true,
  fetchPageSize: 25,
  loadEntityQueryProvider: (query) => SDK.customerPaymentMethods.query(query),
  loadEntityByIdProvider: (entityId: string) =>
    SDK.customerPaymentMethods.getById(entityId),
});

export const LoadAllCustomerPaymentMethods = (
  store: Store<iStore>,
  forceReload?: boolean
) =>
  loadCustomerPaymentMethodsQuery(
    customerPaymentMethodsDefaultQueryConfig,
    "all"
  )(store, forceReload);

export const LoadCustomerPaymentMethodsByBrand = (
  brandId: string,
  store: Store<iStore>,
  forceReload?: boolean
) => {
  const queryConfig: QueryConfig = {
    query: { brandId },
    options: { sortBy: ["createdAt"] },
  };
  return loadCustomerPaymentMethodsQuery(
    queryConfig,
    `byBrand:${brandId}`
  )(store, forceReload);
};
